// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"_7Lszn","container":"oVxWLT"};